export default __webpack_public_path__ + "static/media/LinkImg.0f98f8ea.svg";